import {
    GET_BANK_LIST_PROGRESS, GET_BANK_LIST_SUCCESS, GET_BANK_LIST_FAILURE,
    ADD_BANK_PROGRESS, ADD_BANK_SUCCESS, ADD_BANK_FAILURE,
    EDIT_DELETE_BANK_PROGRESS, EDIT_DELETE_BANK_SUCCESS, EDIT_DELETE_BANK_FAILURE,

    RESET_MESSAGE,
    UPLOAD_BANK_EXCEL_PROGRESS,
    UPLOAD_BANK_EXCEL_SUCCESS,
    UPLOAD_BANK_EXCEL_FAILURE,

} from '../types/actionTypes';

const initialState = {
    bank: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const bank_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BANK_LIST_SUCCESS:
            return { ...state, bank: action.bank, loading: false };
        case GET_BANK_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_BANK_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_BANK_PROGRESS:
            return { ...state, loading: true };
        case ADD_BANK_SUCCESS:
            return { ...state, bank: [...state.bank, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_BANK_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_BANK_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_BANK_SUCCESS:
            return {
                ...state,
                bank: state.bank.map((bank) =>
                    bank.id === action.payload.id ? action.payload : bank
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_BANK_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case UPLOAD_BANK_EXCEL_PROGRESS:
            return { ...state, loading: true };
        case UPLOAD_BANK_EXCEL_SUCCESS:
            return { ...state, bank: [...state.bank, action.payload], loading: false, error: false, message: 'Record uploaded successfully!' };
        case UPLOAD_BANK_EXCEL_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to upload excel file, try again!' };


        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default bank_reducer;